import { createTheme, type MantineTheme, Tooltip } from '@mantine/core';
import type { PartialDeep } from 'type-fest';

export const ThemedMantineTooltip: PartialDeep<MantineTheme> = createTheme({
  components: {
    Tooltip: Tooltip.extend({
      defaultProps: {
        withArrow: true,
        arrowSize: 6,
        radius: 6,
        color: 'purple.2',
        c: 'purple.7',
      },
    }),
  },
});
